<template>
  <div v-if="receipt" class="box-container ma-0 pa-0" :style="`max-height: 80vh; ${isInDarkMode ? 'background-color: rgb(25,25,25)' : 'background-color: #fff'}`">
    <div class="row-header ma-0 pa-0" :style="`width: ${width}px;`">
      <v-row class="ma-0 pa-0" justify="center" align="center">
        <v-btn
          v-if="!hideButtons"
          color="default"
          text
          fab
          small
          @click="
            tableView = !tableView;
            recalcWidth();
          "
        >
          <v-icon>{{ tableView ? "mdi-file-eye-outline" : "mdi-table-eye" }}</v-icon>
        </v-btn>
        <v-divider></v-divider>
        <span class="ma-2" :style="`color: ${color}`">{{ receipt.ReceiptType }}</span>
        <v-divider></v-divider>
        <v-btn v-if="!hideButtons" color="error" text fab small @click="dialog.close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-row v-if="!hideDeviceInfo" class="ma-1 pa-0" justify="space-around" align="center">
        <span>{{ receipt.Device.sn }}</span>
        <span>{{ receipt.Device.model.name }}</span>
        <v-avatar class size="40" tile>
          <v-img :src="receipt.Device.Image" alt="Tremol" width="auto" height="auto" contain></v-img>
        </v-avatar>
      </v-row>
    </div>
    <div class="row-content" :style="`width: ${width}px;`">
      <v-row
        v-if="!tableView || receipt.ReceiptType == types.info || receipt.ReceiptType == types.fuvasAction || receipt.ReceiptType == types.fuvasButton || receipt.ReceiptType == types.telemetry || receipt.ReceiptType == types.telemetry_manual"
        class="ma-0 pa-0"
      >
        <v-row v-if="receipt.ReceiptType == types.telemetry || receipt.ReceiptType == types.telemetry_manual" class="ma-0 pa-0" style="width: 100%">
          <TelemetryView v-if="tableView" :device="receipt.Device" :freeTexts="receipt.freeTexts" :telemetryData="jsonTreeViewTeleData" />
          <JSONView v-if="!tableView" :data="jsonTreeViewTeleData" v-translate class="customize" :style="`font-size: ${isOnMobile ? '12px' : '14px'}`" />
        </v-row>
        <v-col v-else cols="12" :class="isOnMobile ? 'ma-0 pa-0' : ''">
          <v-row justify="center" align="center" class="ma-0 pa-0">
            <div v-for="(l, lIndex) in lines" :key="lIndex">
              <pre v-if="l && mustBeBold(l)" :style="isWithSmallWidth ? 'font-size: 13px;' : ''"><b>{{ l }}</b></pre>
              <pre v-else :style="isWithSmallWidth ? 'font-size: 13px;' : ''">{{ l }}</pre>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-list v-else class="ma-0 pa-0" popout expand dense>
        <v-list-group v-for="(table, tIdx) in getTables" :key="tIdx" v-model="table.active" class="ma-0 pa-0" :color="isInDarkMode ? 'theme' : 'secondary'">
          <template v-slot:activator>
            <v-list-item-title :class="isOnMobile ? 'subtitle-2' : 'subtitle-1'" style="width: 100%; text-decoration: underline">{{ table.title }}</v-list-item-title>
          </template>
          <v-list-item-content class="ma-0 pa-0">
            <v-simple-table dense fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="(h, hIndex) in table.headers" :key="hIndex" style="text-align: center">{{ h.text }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, rIndex) in table.rows" :key="rIndex">
                    <td v-for="(cell, cellIndex) in row" :key="cellIndex" :style="'text-align: ' + table.headers[cellIndex].align + ''">{{ formatCell(table.headers[cellIndex].proptype, cell) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-list-item-content>
        </v-list-group>
      </v-list>
    </div>
  </div>
</template>
<script>
import DataManager, { ReceiptType, DataHeader, DataPropType } from "../../js/DataManager";
import { TR } from "../../main";
import { JSONView } from "vue-json-component";
import { Telemetry } from "../../js/Telemetry";
import TelemetryView from "../Telemetry/TelemetryView";
import Translation from "../../js/Translation";
export default {
  name: "myReceiptView",
  components: {
    JSONView,
    TelemetryView,
  },
  props: {
    rec: null,
    hideButtons: {
      type: Boolean,
      default: false,
    },
    hideDeviceInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jsonTreeViewTeleData: null,
      fpIsNotWide: true,
      width: 400,
      types: ReceiptType,
      tableView: false,
      receipt: this.rec,
      color: null,
      lines: [],
      tables: [],
      lineLength: 32,
    };
  },
  computed: {
    getTables() {
      return this.tables;
    },
  },
  methods: {
    mustBeBold(line) {
      return line.toLowerCase().startsWith(TR.TOTALSUM.toLowerCase()) || line.startsWith(TR.V_O_I_D) || line.startsWith("VMC");
    },
    getTableHeight(tableIndex) {
      if (tableIndex == 0) return "70px";
      else if (tableIndex == 1) return "150px";
      else return "80px";
    },
    formatCell(proptype, value) {
      return DataManager.formatGridData(proptype, value);
    },
    recalcWidth() {
      this.width = this.isWithSmallWidth ? 270 : this.tableView ? 700 : this.fpIsNotWide ? 320 : 500;
    },
    getStornoText(num) {
      switch (num) {
        case "0":
          return "Операторска грешка";
        case "1":
          return "Връщане на стока / рекламация";
        case "2":
          return "Намаление данъчна основа";
      }
    },
    showContent() {
      //console.log(this.receipt);
      this.sn = this.receipt.Device.sn;
      var model = this.receipt.Device.model.name;
      this.fpIsNotWide = !(model.contains("FP05") || model.contains("FP15") || model.contains("FP21") || model.contains("FP27") || model.contains("FP28"));
      this.lineLength = this.isWithSmallWidth || this.fpIsNotWide ? 32 : 46;
      this.lines = [];
      this.tables = [];
      var voidLine = TR.V_O_I_D.padStart(this.lineLength / 2 - 15).padEnd(this.lineLength);
      var emptyLine = "".padEnd(this.lineLength);
      //var separatorLine = "".padEnd(this.lineLength, "- ");

      switch (this.receipt.ReceiptType) {
        case ReceiptType.info:
          this.color = "blue";
          if (this.receipt.freeTexts) {
            this.lines = this.receipt.freeTexts;
          }
          break;

        case ReceiptType.fuvasButton:
          this.color = "blue";
          if (TR.Locale == Translation.bg.Locale && this.receipt.freeTexts) {
            this.lines = this.receipt.freeTexts;
          } else if (this.receipt.freeTexts && this.receipt.freeTexts.length > 2) {
            this.lines = [
              TR.InCash.padEnd(10) +
                Number(this.receipt.freeTexts[0])
                  .toFixed(2)
                  .padStart(this.lineLength - 10),
              TR.Card.padEnd(10) +
                Number(this.receipt.freeTexts[1])
                  .toFixed(2)
                  .padStart(this.lineLength - 10),
              TR.Sales.padEnd(10) +
                Number(this.receipt.freeTexts[2])
                  .toString()
                  .padStart(this.lineLength - 10),
            ];
          }
          break;

        case ReceiptType.status:
          this.color = "blue";
          if (this.receipt.freeTexts) {
            this.receipt.freeTexts.forEach((f) => {
              var r = f.split(":", 2);
              if (r.length == 1) {
                this.lines.push(r[0]);
              } else {
                this.lines.push(r[0] + ": " + r[1].padStart(this.lineLength - r[0].length - 2));
              }
            });
          }
          break;

        case ReceiptType.fuvasAction:
          this.color = "orange";
          this.lines.push((TR.Date + ": " + this.receipt.rcp.date.toTremolFpString()).padEnd(this.lineLength));
          this.lines.push(this.receipt.freeTexts[0].padEnd(this.lineLength));
          this.tables.push({
            title: "Текст",
            headers: [new DataHeader(TR.Date, "", DataPropType.Date, "center"), new DataHeader(TR.Message, "", DataPropType.String, "center")],
            rows: [[this.receipt.rcp.date, this.receipt.freeTexts[0]]],
          });
          break;

        case ReceiptType.telemetry:
        case ReceiptType.telemetry_manual:
          this.lines = this.receipt.freeTexts;
          this.tableView = true;
          //console.log(this.receipt.freeTexts.join("\n"));
          this.jsonTreeViewTeleData = new Telemetry(this.receipt.date, this.lines, this.receipt.Device);
          break;

        case ReceiptType.fiscalReceipt:
        case ReceiptType.invoice:
        case ReceiptType.creditNote:
        case ReceiptType.storno:
          this.color = "green";

          this.lines.push(("# " + this.receipt.operator.name).padEnd(this.lineLength));

          if (this.receipt.invoiceData) {
            this.tables.push({
              title: TR.ClientInfo,
              headers: [
                new DataHeader(TR.Address, "", DataPropType.String, "center"),
                new DataHeader(TR.Company, "", DataPropType.String, "center"),
                new DataHeader(TR.EIK, "", DataPropType.String, "center"),
                new DataHeader(TR.MOL, "", DataPropType.String, "center"),
                new DataHeader(TR.ZDDS, "", DataPropType.String, "center"),
              ],
              rows: [[this.receipt.invoiceData.clientCompanyAddress, this.receipt.invoiceData.clientCompanyName, this.receipt.invoiceData.clientEik, this.receipt.invoiceData.clientMOL, this.receipt.invoiceData.zddsNum]],
            });
            if (this.receipt.ReceiptType === ReceiptType.invoice) {
              this.lines.push(this.center(TR.Original));
              this.lines.push(this.center(TR.Invoice + " N   " + this.receipt.invoiceData.invNum));
            }
          }

          if (this.receipt.rcp.unp) {
            this.lines.push((TR.UNP + ": " + this.receipt.rcp.unp).padEnd(this.lineLength));
          }

          if (this.receipt.storno) {
            this.lines.push(this.center(TR.S_T_O_R_N_O));
            if (this.receipt.storno.reason) {
              this.lines.push(this.center(this.getStornoText(this.receipt.storno.reason)));
            }
            if (this.receipt.ReceiptType === ReceiptType.storno) {
              this.lines.push((TR.Document + ":").padEnd(this.lineLength));
              this.lines.push((this.receipt.storno.relatedToRcpNum + "/" + this.receipt.storno.relatedToRcpDate.toStringWithFormat("dd.MM.yyyy HH:mm:ss")).padStart(this.lineLength));
            } else {
              this.lines.push(this.center(TR.CreditNoteNumber));
              this.lines.push(this.center(this.receipt.invoiceData.invNum + "/" + this.receipt.date.toStringWithFormat("dd.MM.yyyy")));
              this.lines.push(this.center(TR.IssueReason));
              this.lines.push(this.center(TR.ForInvoiceN));
              this.lines.push((this.receipt.storno.invNum + "/" + this.receipt.storno.relatedToRcpDate.toStringWithFormat("dd.MM.yyyy HH:mm:ss")).padStart(this.lineLength));
              this.lines.push((TR.Document + ": " + this.receipt.storno.relatedToRcpNum).padEnd(this.lineLength));
            }

            this.lines.push((TR.FM + ": " + this.receipt.storno.fMnum).padEnd(this.lineLength));
            if (this.receipt.storno.unp && this.receipt.storno.unp.trim()) {
              this.lines.push((TR.UNP + ": " + this.receipt.storno.unp).padEnd(this.lineLength));
            }
            this.lines.push(emptyLine);
          }

          this.tables.push({
            title: TR.ReceiptInfo,
            headers: [
              new DataHeader(TR.Number, "", DataPropType.Number, "center"),
              new DataHeader(TR.Date, "", DataPropType.Date, "center"),
              new DataHeader(TR.Operator, "", DataPropType.String, "center"),
              new DataHeader(TR.Voided, "", DataPropType.BOOL, "center"),
              new DataHeader(TR.TotalSum, "", DataPropType.Money, "center"),
              //, this.receipt.change ? "Ресто" : null] };
            ],
            rows: [
              [
                this.receipt.rcp.rcpNum,
                this.receipt.rcp.date,
                this.receipt.operator.name,
                this.receipt.rcp.void ? TR.Yes : TR.No,
                this.receipt.FinalSum,
              ],
            ],
          });

          if (this.receipt.sales) {
            var lnLast = 1;
            var idx = 0;
            var hasLnum = this.receipt.sales[0].ln;
            this.receipt.sales.forEach((s) => {
              idx = this.lines.length;
              if (s.void) {
                this.lines.push(voidLine);
              }
              this.lines.push(s.name.padEnd(this.lineLength));
              if (s.qty != 1) {
                this.lines.push((s.qty.toFixed(3) + " X " + s.price.toFixed(2)).padStart(this.lineLength));
              }
              var sumStr = TR.Sum + " * " + s.taxGr;
              this.lines.push(sumStr + s.sum.toFixed(2).padStart(this.lineLength - sumStr.length));

              if (hasLnum && this.receipt.discAdds) {
                this.addDiscount(idx, lnLast, s.ln);
                lnLast = s.ln;
              }
            });

            if (hasLnum && this.receipt.discAdds) {
              idx = this.lines.length;
              this.addDiscount(idx, lnLast);
            }

            this.tables.push({
              title: TR.Sales,
              headers: [
                new DataHeader(TR.Article, "", DataPropType.String, "center"),
                new DataHeader(TR.TaxGr, "", DataPropType.String, "center"),
                new DataHeader(TR.Price, "", DataPropType.Money, "center"),
                new DataHeader(TR.Quantity, "", DataPropType.QTY, "center"),
                new DataHeader(TR.Void, "", DataPropType.BOOL, "center"),
                new DataHeader(TR.TotalSum, "", DataPropType.Money, "center"),
              ],
              rows: Object.values(this.receipt.sales.map((o) => [o.name, o.taxGr, o.price, o.qty, o.void ? TR.Yes : TR.No, o.sum])),
            });
          }

          if (this.receipt.rcp.void) {
            this.lines.push(this.voidLine);
          }
          var finalSum = this.receipt.finalSum;
          if (this.receipt.ReceiptType.IsNegative) {
            finalSum = -finalSum;
          }
          this.lines.push((TR.TOTALSUM + " ").padEnd(this.lineLength - finalSum.toFixed(2).length, ".") + finalSum.toFixed(2));

          if (this.receipt.taxGrSums && this.receipt.taxGrSums.length > 0 && !this.receipt.rcp.void) {
            this.receipt.taxGrSums.forEach((v) => {
              var ss = TR.Sum + " * " + v.taxGr;
              this.lines.push(ss + v.sum.toFixed(2).padStart(this.lineLength - ss.length));
              this.lines.push((TR.VAT + " * " + v.taxGr + " (" + v.vatPrc + "%)").padEnd(15) + v.vat.toFixed(2).padStart(this.lineLength - 15));
            });
            this.tables.push({
              title: TR.TurnoverByTaxGroups,
              headers: [new DataHeader(TR.TaxGroup, "", DataPropType.String, "center"), new DataHeader(TR.VAT, "", DataPropType.Money, "center"), new DataHeader(TR.Sum, "", DataPropType.Money, "center")],
              rows: Object.values(this.receipt.taxGrSums.map((o) => [o.taxGr + " (" + o.vatPrc + "%)", o.vat, o.sum])),
            });
          }

          if (this.receipt.payments) {
            //this.lines.push(separatorLine);
            this.receipt.payments.forEach((p) => {
              this.lines.push(p.payType.padEnd(12) + p.sum.toFixed(2).padStart(this.lineLength - 12));
            });
            this.tables.push({
              title: TR.Payments,
              headers: [new DataHeader(TR.Type, "", DataPropType.String, "center"), new DataHeader(TR.Sum, "", DataPropType.Money, "center")],
              rows: Object.values(this.receipt.payments.map((o) => [o.payType, o.sum])),
            });
          }

          if (this.receipt.invoiceData) {
            this.lines.push((TR.Recipient + ": ").padEnd(this.lineLength));
            if (this.receipt.invoiceData.clientCompanyName) {
              this.lines.push(this.receipt.invoiceData.clientCompanyName.padEnd(this.lineLength));
            }
            this.lines.push((TR.Client + ": ").padEnd(this.lineLength));
            if (this.receipt.invoiceData.clientMOL) {
              this.lines.push(this.receipt.invoiceData.clientMOL.padEnd(this.lineLength));
            }
            this.lines.push((TR.Address + ": ").padEnd(this.lineLength));
            if (this.receipt.invoiceData.clientCompanyAddress) {
              this.lines.push(this.receipt.invoiceData.clientCompanyAddress.padEnd(this.lineLength));
            }
            this.lines.push((TR.IdentN + ": " + (this.receipt.invoiceData.clientEik ? this.receipt.invoiceData.clientEik : "")).padEnd(this.lineLength));
            this.lines.push((TR.ZDDS + " N: " + (this.receipt.invoiceData.zddsNum ? this.receipt.invoiceData.zddsNum : "")).padEnd(this.lineLength));
            this.lines.push(emptyLine);
          }

          this.lines.push(this.receipt.rcp.rcpNum.toString().padStart(6, "0") + this.receipt.rcp.date.toTremolFpString().padStart(this.lineLength - 6, " "));
          break;
      }

      this.recalcWidth();
      this.tables.filter((t) => t.title == TR.ReceiptInfo || t.title == TR.Sales).forEach((t) => (t.active = true));
    },
    center(txt) {
      return txt
        .trim()
        .padStart((this.lineLength + txt.trim().length) / 2)
        .padEnd(this.lineLength);
    },
    addDiscount(idx, lnPrev, lnCurr) {
      var subAdded = false;
      var das = this.receipt.discAdds.filter((da) => da.ln > lnPrev && (lnCurr ? da.ln < lnCurr : true));
      das.forEach((d) => {
        if (d.flagTrans == 48 && !subAdded) {
          this.lines.splice(idx++, 0, TR.Subtotal.padEnd(this.lineLength)); //TODO нямаме на междинната сума тоталката???
          subAdded = true;
        }
        var l = (d.flagDisc == 48 ? TR.Addition : TR.Discount) + "*" + d.taxGr + " ";
        if (d.flagPrc == 49) l += (d.value.toFixed(2) + "%").padStart(6);
        else l += "      ";
        l += d.sum.toFixed(2).padStart(this.lineLength - 17);
        this.lines.splice(idx++, 0, l);
      });
    },
  },
  created() {},
  mounted() {
    if (this.receipt == null) {
      this.receipt = this.dialog.data;
    }
    //console.log(JSON.stringify(this.receipt));
    if (this.receipt != null) this.showContent();
    else this.dialog.close();
  },

  watch: {},
};
</script>

<style scoped>
.customize {
  font-size: 15px;
  --vjc-key-color: #0977e6;
  --vjc-valueKey-color: #073642;
  --vjc-string-color: #268bd2;
  --vjc-number-color: #2aa198;
  --vjc-boolean-color: #cb4b16;
  --vjc-null-color: #6c71c4;
  --vjc-arrow-size: 2px;
  --vjc-arrow-color: #444;
  --vjc-hover-color: rgba(0, 0, 0, 0.15);
}
.vm--overlay {
  background: rgba(0, 0, 0, 0.8);
}
.modal-style {
  padding: 10px;
  font-style: 12px;
  border-radius: 1px;
  border: 1px solid gray;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
.modal-border {
  border: 1px solid gray;
}
</style>
